<div *ngIf="loader.loading$|async" class="pageloader">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<div *ngIf="loader.loading_percentage$|async" class="pageloader">
  <mat-progress-bar mode="determinate" [value]="loader.loading_percentage$|async"></mat-progress-bar>
</div>

